import { ViewComponentProps } from '@databases/fields/view/types';
import { defaultStoreUtils } from '@databases/redux';
import { selectDatabaseDraftByContentId } from '@databases/redux/changesets/selectors';
import { DatabaseFieldType } from '@databases/types/database';
import { RECURSION_LIMIT } from '@databases/utils/constants';
import { getEntryDetailsTargetValues } from '@databases/utils/database/field-types/entryDetails';
import { getDatabaseEntryRequired } from '@databases/utils/database/utils';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { useScope } from '../../Scope';
import { InternalDatabaseValueView } from '../../database-value/DatabaseValueView';
import { getSelectDatabaseDraft } from '../../database-value/utils';

const Container = styled.ul`
  list-style-type: none;
  padding: 0;

  > li + li {
    margin-top: 6px;
  }
`;

const EntryDetailsValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.ENTRY_DETAILS>
> = ({ contentId, field, entryId, recursionCount, ...props }) => {
  const scope = useScope();
  const targetValues = defaultStoreUtils.useEqualSelector((state) => {
    const databaseDraft = selectDatabaseDraftByContentId(state, {
      contentId,
      scope,
      includeDeleted: true,
    });
    const entry = entryId ? getDatabaseEntryRequired(databaseDraft, entryId) : undefined;

    return getEntryDetailsTargetValues({ database: databaseDraft, field, entry }, state, {
      selectDatabase: getSelectDatabaseDraft(scope, true),
    });
  });

  if (targetValues.length === 0 || recursionCount >= RECURSION_LIMIT) {
    return null;
  } else {
    return (
      <Container>
        {targetValues.map((targetValue, i) => (
          <li key={`${i}`}>
            <InternalDatabaseValueView
              {...props}
              contentId={targetValue.database.contentId}
              entryId={targetValue.entry.id}
              field={targetValue.field}
              value={targetValue.value}
              recursionCount={recursionCount + 1}
            />
          </li>
        ))}
      </Container>
    );
  }
};

export default EntryDetailsValueView;
